export const ALLOWED_VENDOR_REPORTS = new Set<string>([
  'county criminal',
  'county criminal report',
  'statewide criminal',
  'statewide criminal report',
  'landlord verification',
  'employment verification',
  'eviction verification',
  'dmv report',
  'business credit'
]);

export const UPLOAD_ICON_VENDOR_REPORTS = new Set<string>([
  'dmv report',
  'business credit'
]);

const normalizeKey = (value: string = ''): string => value.toLowerCase().replace(/[^a-z]/g, '');

const ALLOWED_VENDOR_REPORT_KEYS = new Set<string>(
  Array.from(ALLOWED_VENDOR_REPORTS).map((reportName) => normalizeKey(reportName))
);

const UPLOAD_ICON_VENDOR_REPORT_KEYS = new Set<string>(
  Array.from(UPLOAD_ICON_VENDOR_REPORTS).map((reportName) => normalizeKey(reportName))
);

// Keep backward compatibility for legacy typo values returned by old records.
ALLOWED_VENDOR_REPORT_KEYS.add('landloardverification');

export function normalizeVendorReportName(value: string = ''): string {
  return (value || '').toLowerCase().replace(/[^a-z]/g, '');
}

export function isAllowedVendorReport(value: string = ''): boolean {
  return ALLOWED_VENDOR_REPORT_KEYS.has(normalizeVendorReportName(value));
}

export function isUploadIconVendorReport(value: string = ''): boolean {
  return UPLOAD_ICON_VENDOR_REPORT_KEYS.has(normalizeVendorReportName(value));
}

export function isLandlordVerificationReport(value: string = ''): boolean {
  const normalized = normalizeVendorReportName(value);
  return normalized.includes('landlordverification') || normalized.includes('landloardverification');
}

export function isEmploymentVerificationReport(value: string = ''): boolean {
  return normalizeVendorReportName(value).includes('employment');
}

export function isThirdPartyViewVendorReport(value: string = ''): boolean {
  return isUploadIconVendorReport(value)
    || isEmploymentVerificationReport(value)
    || isLandlordVerificationReport(value);
}
